export default "__VITE_ASSET__4da3e883__"